/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-chart-gauge-pointer-stroke',
  templateUrl: './theme-option-elements-chart-gauge-pointer-stroke.component.html',
  styleUrls: ['./theme-option-elements-chart-gauge-pointer-stroke.component.css']
})
export class ThemeOptionElementsChartGaugePointerStrokeComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_chart_gauge_pointer_stroke';

  constructor() {}

  receiveValue(value: string) {
    console.log(this.themeOptions.optionsConfiguration[this.optionType].categories)
    this.themeOptions.setOption(this.optionType, value);
  }

}
